import { CHECKOUT_STEPS } from "@repo/constants/checkout";
import { useStepper } from "@repo/lib/hooks/checkout";
import { getUserSessionServer } from "@repo/lib/utils";
import { useCallback, useTransition } from "react";

const useCheckoutSteps = (session, cart) => {
  const [isPending, startTransition] = useTransition();
  const {
    activeStepper,
    completedSteps,
    handleStepChange,
    handleAddressComplete,
    handleGuestSelection,
    setActiveStepper,
    setCompletedSteps,
  } = useStepper(session, cart);

  const handleCheckoutSignIn = useCallback(async () => {
    startTransition(async () => {
      const session = await getUserSessionServer();
      if (session) {
        handleAddressComplete();
        setCompletedSteps((prev) => ({
          ...prev,
          [CHECKOUT_STEPS.ACCOUNT]: true,
        }));
        setActiveStepper(CHECKOUT_STEPS.ADDRESS);
      }
    });
  }, [handleAddressComplete, setActiveStepper, setCompletedSteps]);

  return {
    handleCheckoutSignIn,
    isPending,
    activeStepper,
    completedSteps,
    handleStepChange,
    handleAddressComplete,
    handleGuestSelection,
  };
};

export default useCheckoutSteps;
